// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channels-page {
  max-width: var(--max-width-10xl, 120rem);
  margin: 0 auto;
  padding: 22px 24px 48px;
  font-family: "DM Sans", sans-serif;
  color: #2b2b35;
}

.channels-head {
  margin-bottom: 18px;
}
.channels-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #20202a;
}
.channels-sub {
  margin: 4px 0 0;
  font-size: 13.5px;
  color: #82828e;
}

/* ── Toolbar: filter chips on the left, search on the right ─────────── */
.channels-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  /* Top room for the filter count badge (top:-10px); bottom gap to the grid. */
  margin: 8px 0 20px;
}
.channels-toolbar .channels-filters {
  margin: 0;
}
.channels-search {
  margin-left: auto;
}
.channels-search-empty {
  margin: 8px 0 0;
  font-size: 14px;
  color: #82828e;
}

/* ── Top filter (reuses the Activity → Inbox \`.platform-filter\` chips) ── */
.channels-filters {
  /* Top room for the count badge that sits at top:-10px; bottom gap to the grid. */
  margin: 4px 0 20px;
  padding-left: 0;
  padding-right: 0;
}
/* Don't run the backwards "un-draw" border on the inactive chips at first paint
   (only after the user switches filters). */
.channels-filters.no-undraw .platform-filter:not(.active) .platform-filter-border-rect {
  animation: none;
}

/* ── Grid of channel cards ─────────────────────────────────────────── */
.channels-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.channel-card {
  display: flex;
  flex-direction: column;
  min-height: 172px;
  padding: 20px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  will-change: transform;
  backface-visibility: hidden;
  transition: border-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.channel-card:hover {
  border-color: #cbb9f4;
  transform: translateY(-1px);
}

.channel-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 11px;
  background: #f6f5f9;
  border: 1px solid #ececf1;
  margin-bottom: 14px;
  flex-shrink: 0;
}
.channel-card-icon img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}
/* Wide wordmarks (Webflow / WordPress) — render larger so they're legible. */
.channel-card-icon.wide img {
  width: 42px;
  height: auto;
}
.channel-card-icon svg {
  font-size: 24px;
  color: #5616ea;
}
/* Telegram's glyph reads smaller than the brand logos — bump it. */
.channel-card-icon .ch-glyph-telegram {
  font-size: 36px;
}
/* Lettermark fallback for platforms without a brand SVG (Jimdo, Tilda…). */
.ch-monogram {
  font-family: "DM Sans", sans-serif;
  font-weight: 800;
  font-size: 19px;
  line-height: 1;
  letter-spacing: -0.02em;
}
.channel-modal-icon .ch-monogram {
  font-size: 15px;
}

.channel-card-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #20202a;
}
.channel-card-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #fff;
  background: #1f1147;
  border-radius: 999px;
  padding: 2px 8px;
  text-transform: none;
}

.channel-card-desc {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.5;
  color: #6c6c78;
}

.channel-card-cta {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  align-self: flex-end;
  margin-top: auto;
  padding-top: 14px;
  font-size: 13.5px;
  font-weight: 600;
  color: #5616ea;
}
.channel-card-cta svg {
  font-size: 11px;
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.channel-card:hover .channel-card-cta svg {
  transform: translateX(3px);
}

/* Help section under the grid (moved out of the per-channel modals).
   No background — just a thin divider above it, centered. */
.channels-help {
  margin-top: 28px;
  padding-top: 28px;
  border-top: 1px solid #e7e7ec;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.channels-help-header {
  display: flex;
  align-items: center;
  gap: 9px;
}
.channels-help-header svg {
  color: #5616ea;
  font-size: 18px;
}
.channels-help-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #20202a;
}
.channels-help p {
  margin: 8px 0 16px;
  max-width: 520px;
  font-size: 13.5px;
  line-height: 1.5;
  color: #6c6c78;
}
.channels-help-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background: #5616ea;
  color: #fff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.channels-help-btn:hover {
  background: #4a14d6;
  transform: translateY(-1px);
}

/* ── Modal ─────────────────────────────────────────────────────────── */
.channel-modal-overlay {
  position: fixed;
  inset: 0;
  /* Below MUI's default Modal z-index (1300) so the social connect flows
     (SelectBot / Telegram / Slack) surface ABOVE this modal, not behind it. */
  z-index: 1200;
  display: flex;
  padding: 48px 16px;
  background: rgba(20, 12, 40, 0.45);
  overflow-y: auto;
}
.channel-modal {
  /* \`margin: auto\` (inside the flex + scrollable overlay) centres the modal
     on both axes when it fits, and keeps it fully scrollable from the top
     when it's taller than the viewport — unlike align-items: center, which
     would clip the top of a tall modal. */
  margin: auto;
  width: 780px;
  max-width: 100%;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 24px 60px -20px rgba(20, 10, 50, 0.5);
  overflow: hidden;
  font-family: "DM Sans", sans-serif;
}
.channel-modal-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid #eeecf3;
}
.channel-modal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: #f6f5f9;
  border: 1px solid #ececf1;
  flex-shrink: 0;
}
.channel-modal-icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.channel-modal-icon.wide img {
  width: 30px;
  height: auto;
}
.channel-modal-icon svg {
  font-size: 17px;
  color: #5616ea;
}
.channel-modal-title {
  flex: 1 1 auto;
  font-size: 17px;
  font-weight: 700;
  color: #20202a;
}
.channel-modal-close,
.channel-modal-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #6b6b78;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.channel-modal-close:hover,
.channel-modal-back:hover {
  background: #f2eefe;
  color: #5616ea;
}
.channel-modal-back { color: #5616ea; }
.channel-modal-back:focus-visible,
.channel-modal-close:focus-visible { outline: 2px solid #5616ea; outline-offset: 2px; }
.channel-modal-back:disabled,
.channel-modal-close:disabled { opacity: 0.45; cursor: default; }

/* Header and action footer stay put; only the space between them scrolls. */
.channel-modal--social {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 96px);
  max-height: calc(100dvh - 96px);
}
.channel-modal--social .channel-modal-head,
.channel-modal-footer-slot { flex-shrink: 0; }
.channel-modal-footer-slot:empty { display: none; }
.channel-modal--social .channel-modal-body {
  min-height: 0;
  max-height: none;
  flex: 1 1 auto;
  overscroll-behavior: contain;
}
@media (max-width: 600px) {
  .channel-modal-overlay { padding: 16px; }
  .channel-modal--social {
    max-height: calc(100vh - 32px);
    max-height: calc(100dvh - 32px);
  }
}
.channel-modal-body {
  padding: 20px;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

/* Flatten Integration's nested white container inside the modal — the modal
   already provides the surface, so the boxed look is redundant. The content
   just aligns directly in the modal body. */
.channel-modal-body .integration-page {
  margin: 0;
}
.channel-modal-body .integration-tab-content {
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
}

/* Snippet sub-tabs (reused Activity-Inbox filter chips): align flush with the
   modal content (no extra padding/margin from \`.platform-filters\`)… */
.channel-modal-body .snippet-mode-filters {
  padding: 0;
  margin: 0 0 12px;
}
/* …and don't run the backwards "un-draw" border animation on the inactive
   tab when the modal first opens (only after the user switches tabs). */
.channel-modal-body .snippet-mode-filters.no-undraw .platform-filter:not(.active) .platform-filter-border-rect {
  animation: none;
}

/* Social channel content fills the modal — flatten the card so it isn't a
   boxed component-in-a-component. */
.channel-modal-body .channel-social-grid {
  display: block;
  width: 100%;
  margin-top: 0;
}
.channel-modal-body .social-platform-card {
  background: transparent;
  border: none;
  box-shadow: none;
  width: 100%;
  max-width: none;
  min-width: 0;
  padding: 0;
  margin: 0;
}
.channel-modal-body .platform-card-content {
  width: 100%;
  max-width: none;
  padding: 0;
}

/* Inline "Manage connections" view (instead of a second modal behind). */
.channel-modal-body .manage-connections-inline {
  width: 100%;
}
.social-inline-back {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 14px;
  padding: 7px 13px;
  border: 1px solid #e4e4ea;
  border-radius: 8px;
  background: #fff;
  color: #5a5a66;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.social-inline-back svg {
  font-size: 11px;
}
.social-inline-back:hover {
  background: #f7f4ff;
  border-color: #cbb9f4;
  color: #5616ea;
}

/* Smooth modal size change + view shift (card ↔ manage). */
.channel-modal-morph {
  transition: height 0.32s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}
@keyframes channelViewIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.channel-modal-body .channel-social-grid,
.channel-modal-body .manage-connections-inline,
.channel-modal-body .social-inline-back {
  animation: channelViewIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/ChannelsPage.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6EAA6E;EAC7E,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,iFAAiF;EACjF,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;4CAC4C;AAC5C;EACE,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,wFAAwF;AAC1F;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,6EAA6E;AAC7E;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA,mEAAmE;AACnE;EACE,eAAe;AACjB;AACA,2EAA2E;AAC3E;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gEAAgE;AAClE;AACA;EACE,0BAA0B;AAC5B;;AAEA;4DAC4D;AAC5D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4FAA4F;AAC9F;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,QAAQ;EACR;8EAC4E;EAC5E,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE;;;0CAGwC;EACxC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mDAAmD;EACnD,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA,sBAAsB,cAAc,EAAE;AACtC;qCACqC,0BAA0B,EAAE,mBAAmB,EAAE;AACtF;gCACgC,aAAa,EAAE,eAAe,EAAE;;AAEhE,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;6BAC6B,cAAc,EAAE;AAC7C,mCAAmC,aAAa,EAAE;AAClD;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,yBAAyB,aAAa,EAAE;EACxC;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;AACF;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;4CAE4C;AAC5C;EACE,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;sEACsE;AACtE;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;wEACwE;AACxE;EACE,eAAe;AACjB;;AAEA;oCACoC;AACpC;EACE,cAAc;EACd,WAAW;EACX,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA,yEAAyE;AACzE;EACE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;;;EAGE,0DAA0D;AAC5D","sourcesContent":[".channels-page {\r\n  max-width: var(--max-width-10xl, 120rem);\r\n  margin: 0 auto;\r\n  padding: 22px 24px 48px;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  color: #2b2b35;\r\n}\r\n\r\n.channels-head {\r\n  margin-bottom: 18px;\r\n}\r\n.channels-title {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.channels-sub {\r\n  margin: 4px 0 0;\r\n  font-size: 13.5px;\r\n  color: #82828e;\r\n}\r\n\r\n/* ── Toolbar: filter chips on the left, search on the right ─────────── */\r\n.channels-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  /* Top room for the filter count badge (top:-10px); bottom gap to the grid. */\r\n  margin: 8px 0 20px;\r\n}\r\n.channels-toolbar .channels-filters {\r\n  margin: 0;\r\n}\r\n.channels-search {\r\n  margin-left: auto;\r\n}\r\n.channels-search-empty {\r\n  margin: 8px 0 0;\r\n  font-size: 14px;\r\n  color: #82828e;\r\n}\r\n\r\n/* ── Top filter (reuses the Activity → Inbox `.platform-filter` chips) ── */\r\n.channels-filters {\r\n  /* Top room for the count badge that sits at top:-10px; bottom gap to the grid. */\r\n  margin: 4px 0 20px;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n/* Don't run the backwards \"un-draw\" border on the inactive chips at first paint\r\n   (only after the user switches filters). */\r\n.channels-filters.no-undraw .platform-filter:not(.active) .platform-filter-border-rect {\r\n  animation: none;\r\n}\r\n\r\n/* ── Grid of channel cards ─────────────────────────────────────────── */\r\n.channels-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.channel-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 172px;\r\n  padding: 20px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  background: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n  transition: border-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.channel-card:hover {\r\n  border-color: #cbb9f4;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.channel-card-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 11px;\r\n  background: #f6f5f9;\r\n  border: 1px solid #ececf1;\r\n  margin-bottom: 14px;\r\n  flex-shrink: 0;\r\n}\r\n.channel-card-icon img {\r\n  width: 38px;\r\n  height: 38px;\r\n  object-fit: contain;\r\n}\r\n/* Wide wordmarks (Webflow / WordPress) — render larger so they're legible. */\r\n.channel-card-icon.wide img {\r\n  width: 42px;\r\n  height: auto;\r\n}\r\n.channel-card-icon svg {\r\n  font-size: 24px;\r\n  color: #5616ea;\r\n}\r\n/* Telegram's glyph reads smaller than the brand logos — bump it. */\r\n.channel-card-icon .ch-glyph-telegram {\r\n  font-size: 36px;\r\n}\r\n/* Lettermark fallback for platforms without a brand SVG (Jimdo, Tilda…). */\r\n.ch-monogram {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  font-weight: 800;\r\n  font-size: 19px;\r\n  line-height: 1;\r\n  letter-spacing: -0.02em;\r\n}\r\n.channel-modal-icon .ch-monogram {\r\n  font-size: 15px;\r\n}\r\n\r\n.channel-card-name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.channel-card-badge {\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.3px;\r\n  color: #fff;\r\n  background: #1f1147;\r\n  border-radius: 999px;\r\n  padding: 2px 8px;\r\n  text-transform: none;\r\n}\r\n\r\n.channel-card-desc {\r\n  margin-top: 6px;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  color: #6c6c78;\r\n}\r\n\r\n.channel-card-cta {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  align-self: flex-end;\r\n  margin-top: auto;\r\n  padding-top: 14px;\r\n  font-size: 13.5px;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n}\r\n.channel-card-cta svg {\r\n  font-size: 11px;\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.channel-card:hover .channel-card-cta svg {\r\n  transform: translateX(3px);\r\n}\r\n\r\n/* Help section under the grid (moved out of the per-channel modals).\r\n   No background — just a thin divider above it, centered. */\r\n.channels-help {\r\n  margin-top: 28px;\r\n  padding-top: 28px;\r\n  border-top: 1px solid #e7e7ec;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n.channels-help-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n}\r\n.channels-help-header svg {\r\n  color: #5616ea;\r\n  font-size: 18px;\r\n}\r\n.channels-help-header h3 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.channels-help p {\r\n  margin: 8px 0 16px;\r\n  max-width: 520px;\r\n  font-size: 13.5px;\r\n  line-height: 1.5;\r\n  color: #6c6c78;\r\n}\r\n.channels-help-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 18px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.channels-help-btn:hover {\r\n  background: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* ── Modal ─────────────────────────────────────────────────────────── */\r\n.channel-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  /* Below MUI's default Modal z-index (1300) so the social connect flows\r\n     (SelectBot / Telegram / Slack) surface ABOVE this modal, not behind it. */\r\n  z-index: 1200;\r\n  display: flex;\r\n  padding: 48px 16px;\r\n  background: rgba(20, 12, 40, 0.45);\r\n  overflow-y: auto;\r\n}\r\n.channel-modal {\r\n  /* `margin: auto` (inside the flex + scrollable overlay) centres the modal\r\n     on both axes when it fits, and keeps it fully scrollable from the top\r\n     when it's taller than the viewport — unlike align-items: center, which\r\n     would clip the top of a tall modal. */\r\n  margin: auto;\r\n  width: 780px;\r\n  max-width: 100%;\r\n  background: #fff;\r\n  border-radius: 14px;\r\n  box-shadow: 0 24px 60px -20px rgba(20, 10, 50, 0.5);\r\n  overflow: hidden;\r\n  font-family: \"DM Sans\", sans-serif;\r\n}\r\n.channel-modal-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 16px 18px;\r\n  border-bottom: 1px solid #eeecf3;\r\n}\r\n.channel-modal-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 9px;\r\n  background: #f6f5f9;\r\n  border: 1px solid #ececf1;\r\n  flex-shrink: 0;\r\n}\r\n.channel-modal-icon img {\r\n  width: 28px;\r\n  height: 28px;\r\n  object-fit: contain;\r\n}\r\n.channel-modal-icon.wide img {\r\n  width: 30px;\r\n  height: auto;\r\n}\r\n.channel-modal-icon svg {\r\n  font-size: 17px;\r\n  color: #5616ea;\r\n}\r\n.channel-modal-title {\r\n  flex: 1 1 auto;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.channel-modal-close,\r\n.channel-modal-back {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 34px;\r\n  flex-shrink: 0;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: transparent;\r\n  color: #6b6b78;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n.channel-modal-close:hover,\r\n.channel-modal-back:hover {\r\n  background: #f2eefe;\r\n  color: #5616ea;\r\n}\r\n.channel-modal-back { color: #5616ea; }\r\n.channel-modal-back:focus-visible,\r\n.channel-modal-close:focus-visible { outline: 2px solid #5616ea; outline-offset: 2px; }\r\n.channel-modal-back:disabled,\r\n.channel-modal-close:disabled { opacity: 0.45; cursor: default; }\r\n\r\n/* Header and action footer stay put; only the space between them scrolls. */\r\n.channel-modal--social {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: calc(100vh - 96px);\r\n  max-height: calc(100dvh - 96px);\r\n}\r\n.channel-modal--social .channel-modal-head,\r\n.channel-modal-footer-slot { flex-shrink: 0; }\r\n.channel-modal-footer-slot:empty { display: none; }\r\n.channel-modal--social .channel-modal-body {\r\n  min-height: 0;\r\n  max-height: none;\r\n  flex: 1 1 auto;\r\n  overscroll-behavior: contain;\r\n}\r\n@media (max-width: 600px) {\r\n  .channel-modal-overlay { padding: 16px; }\r\n  .channel-modal--social {\r\n    max-height: calc(100vh - 32px);\r\n    max-height: calc(100dvh - 32px);\r\n  }\r\n}\r\n.channel-modal-body {\r\n  padding: 20px;\r\n  max-height: calc(100vh - 220px);\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Flatten Integration's nested white container inside the modal — the modal\r\n   already provides the surface, so the boxed look is redundant. The content\r\n   just aligns directly in the modal body. */\r\n.channel-modal-body .integration-page {\r\n  margin: 0;\r\n}\r\n.channel-modal-body .integration-tab-content {\r\n  background: transparent;\r\n  backdrop-filter: none;\r\n  -webkit-backdrop-filter: none;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  padding: 0;\r\n}\r\n\r\n/* Snippet sub-tabs (reused Activity-Inbox filter chips): align flush with the\r\n   modal content (no extra padding/margin from `.platform-filters`)… */\r\n.channel-modal-body .snippet-mode-filters {\r\n  padding: 0;\r\n  margin: 0 0 12px;\r\n}\r\n/* …and don't run the backwards \"un-draw\" border animation on the inactive\r\n   tab when the modal first opens (only after the user switches tabs). */\r\n.channel-modal-body .snippet-mode-filters.no-undraw .platform-filter:not(.active) .platform-filter-border-rect {\r\n  animation: none;\r\n}\r\n\r\n/* Social channel content fills the modal — flatten the card so it isn't a\r\n   boxed component-in-a-component. */\r\n.channel-modal-body .channel-social-grid {\r\n  display: block;\r\n  width: 100%;\r\n  margin-top: 0;\r\n}\r\n.channel-modal-body .social-platform-card {\r\n  background: transparent;\r\n  border: none;\r\n  box-shadow: none;\r\n  width: 100%;\r\n  max-width: none;\r\n  min-width: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.channel-modal-body .platform-card-content {\r\n  width: 100%;\r\n  max-width: none;\r\n  padding: 0;\r\n}\r\n\r\n/* Inline \"Manage connections\" view (instead of a second modal behind). */\r\n.channel-modal-body .manage-connections-inline {\r\n  width: 100%;\r\n}\r\n.social-inline-back {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  margin-bottom: 14px;\r\n  padding: 7px 13px;\r\n  border: 1px solid #e4e4ea;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #5a5a66;\r\n  font-family: inherit;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\r\n}\r\n.social-inline-back svg {\r\n  font-size: 11px;\r\n}\r\n.social-inline-back:hover {\r\n  background: #f7f4ff;\r\n  border-color: #cbb9f4;\r\n  color: #5616ea;\r\n}\r\n\r\n/* Smooth modal size change + view shift (card ↔ manage). */\r\n.channel-modal-morph {\r\n  transition: height 0.32s cubic-bezier(0.4, 0, 0.2, 1);\r\n  overflow: hidden;\r\n}\r\n@keyframes channelViewIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(8px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n.channel-modal-body .channel-social-grid,\r\n.channel-modal-body .manage-connections-inline,\r\n.channel-modal-body .social-inline-back {\r\n  animation: channelViewIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
